import { render, staticRenderFns } from "./SchoolNews.vue?vue&type=template&id=3ca3a692&"
import script from "./SchoolNews.vue?vue&type=script&lang=js&"
export * from "./SchoolNews.vue?vue&type=script&lang=js&"
import style0 from "./SchoolNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports